"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationFrameEngine = void 0;
const AnimationFrameEngine_1 = require("./implementation/AnimationFrameEngine");
Object.defineProperty(exports, "AnimationFrameEngine", { enumerable: true, get: function () { return AnimationFrameEngine_1.AnimationFrameEngine; } });
//# sourceMappingURL=index.js.map